<script setup lang="ts">
import { Coins, Shield, UserRoundX } from 'lucide-vue-next'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { onBeforeUnmount, ref } from 'vue'
import { firebaseClient } from '@/firebase'

interface AdminAccount { id: string; status: string; entitledSlots?: number; monthlyCostLimitCents?: number; updatedAt: number }
const accounts = ref<readonly AdminAccount[]>([])
const busy = ref('')
const stop = onSnapshot(query(collection(firebaseClient.firestore, 'accounts'), orderBy('updatedAt', 'desc')),
  (snapshot) => { accounts.value = snapshot.docs.map((item) => ({ id: item.id, ...item.data() }) as AdminAccount) })
onBeforeUnmount(stop)
const grant = async (account: AdminAccount) => {
  const amount = Number(window.prompt(`Credits to add to ${account.id} (negative to reclaim):`, '1000'))
  if (!Number.isInteger(amount) || amount === 0) return
  const reason = window.prompt('Reason (recorded in the audit log):', 'Support credit')?.trim()
  if (!reason) return
  busy.value = account.id
  try { await httpsCallable(firebaseClient.functions, 'adminGrantCredits')({ accountId: account.id, credits: amount, reason }) }
  finally { busy.value = '' }
}
const suspend = async (account: AdminAccount) => {
  busy.value = account.id
  try { await httpsCallable(firebaseClient.functions, 'adminSetAccountSuspension')({ accountId: account.id, suspended: account.status !== 'suspended' }) }
  finally { busy.value = '' }
}
</script>

<template><div class="section-page"><header class="section-page__header"><div><span class="eyebrow">Operations</span><h1>Admin</h1><p>Suspend compromised accounts, inspect entitlement posture, and recover access without editing production data directly.</p></div></header>
  <section class="detail-card detail-card--wide"><div class="detail-card__head"><div><span class="eyebrow">Accounts</span><h2>Control plane</h2></div><Shield :size="18" /></div>
    <div class="team-list"><div v-for="account in accounts" :key="account.id"><span><strong>{{ account.id }}</strong><small>{{ account.status }} · {{ account.entitledSlots || 0 }} slots</small></span><button class="button" type="button" :disabled="busy === account.id" @click="grant(account)"><Coins :size="15" /> Grant credits</button><button class="button" type="button" :disabled="busy === account.id" @click="suspend(account)"><UserRoundX :size="15" /> {{ account.status === 'suspended' ? 'Reactivate' : 'Suspend' }}</button></div></div>
  </section></div></template>
